<template>
    <page-base>
        <template slot="content">
            <b-card>
                <b-alert variant="danger" :show="showAlert">
                    {{ alert }}
                </b-alert>
                <b-alert variant="success" :show="showSuccessAlert">
                    {{ alert }}
                </b-alert>
                <b-form @submit.prevent="changePassword">
                    <b-form-group :label="$t('person.lastname')" label-cols-sm="3">
                        <b-form-input :value="$store.getters.lastName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('person.firstname')" label-cols-sm="3">
                        <b-form-input :value="$store.getters.firstName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('person.middlename')" label-cols-sm="3">
                        <b-form-input :value="$store.getters.middleName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('general.role')" label-cols-sm="3">
                        <b-form-input :value="$t(`role.${$store.getters.getUserRole}`)" disabled></b-form-input>
                    </b-form-group>
                    <hr />
                    <b-form-group :label="$t('person.login')" label-cols-sm="3">
                        <b-form-input :value="$store.getters.getUserName" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('person.newPassword')" label-cols-sm="3">
                        <b-form-input v-model="formData.password" type="password" :state="isValid"
                            aria-describedby="inputLiveHelp"></b-form-input>
                        <b-form-text id="inputLiveHelp">
                            {{ $t('person.passwordRequirements') }}
                        </b-form-text>
                    </b-form-group>
                    <b-form-group :label="$t('person.confirmPassword')" label-cols-sm="3">
                        <b-form-input v-model="confirmedPassword" type="password" :state="isMatching"
                            aria-describedby="notMatchingFeedback"></b-form-input>
                        <b-form-invalid-feedback id="notMatchingFeedback">
                            {{ $t('errors.passwordDontMatch') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-row class="mx-0">
                        <b-button type="submit" variant="success" class="ml-auto">
                            <save-icon title="" />&nbsp;{{ $t('general.save') }}
                        </b-button>
                    </b-form-row>
                </b-form>
            </b-card>
        </template>
    </page-base>
</template>
<script>
/* eslint-disable */
import { isPasswordValid } from '../validators/FormValidators';

export default {
    name: 'Profile',
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                password: null
            },
            confirmedPassword: null
        }
    },
    computed: {
        isValid() {
            if (this.formData.password === null)
                return null;

            return isPasswordValid(this.formData.password);
        },
        isMatching() {
            if (this.confirmedPassword === null)
                return null;

            return this.formData.password === this.confirmedPassword;
        }
    },
    methods: {
        changePassword() {
            this.hideAlert()
            if (!this.isMatching) {
                this.displayAlert('passwordDontMatch');
                return;
            }

            if (!this.isValid) {
                this.displayAlert('passwordNotValid');
                return;
            }

            const onSuccess = response => {
                this.showSuccessAlert = true;
                this.alert = this.$i18n.t('person.passwordChangedMessage');
            };

            const encodedPassword = btoa(this.formData.password);

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.person.changePass,
                { password: encodedPassword },
                onSuccess, 
                this.displayAlert);
        },
        hideAlert() {
            this.showAlert = false;
            this.alert = '';
        },
        displayAlert(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`);
            this.showAlert = true;
        }
    }
}
</script>
